interface CreateIntersectionObserverParams {
  elements?: Element[];
  options?: IntersectionObserverInit;
}
type ObserverCallback = (entry: IntersectionObserverEntry) => void;

const prepareObserverCallback = (entries: IntersectionObserverEntry[], cb: ObserverCallback) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      cb(entry);
    }
  });
};

export const createIntersectionObserver = (
  cb: ObserverCallback,
  { options, elements }: CreateIntersectionObserverParams
) => {
  if (process.server) return;
  const observer = new IntersectionObserver(
    (entries) => prepareObserverCallback(entries, cb),
    options
  );

  elements?.forEach((element) => observer.observe(element));

  return observer;
};
